<template src="./riepilogoMensile.html"></template>

<script>
import {
  get_riepilogoMensile,
  get_pdfOrdini,
  get_riepilogoGiorno,
} from "@/api/api.ordini.js";

import calendar from "@/components/ui/Calendar";

export default {
  components: { calendar },
  data: function () {
    return {
      dati: [],

      headers: [
        {
          text: "Cliente",
          align: "center",
          value: "RagSociale",
          valueF: "RagSociale",
        },
        {
          text: "Totale",
          align: "center",
          value: "TotMesi",
          valueF: "TotMesiImp",
        },
        {
          text: "Gennaio",
          align: "center",
          value: "Gennaio",
          valueF: "GennaioImp",
        },
        {
          text: "Febbraio",
          align: "center",
          value: "Febbraio",
          valueF: "FebbraioImp",
        },
        {
          text: "Marzo",
          align: "center",
          value: "Marzo",
          valueF: "MarzoImp",
        },
        {
          text: "Aprile",
          align: "center",
          value: "Aprile",
          valueF: "AprileImp",
        },
        {
          text: "Maggio",
          align: "center",
          value: "Maggio",
          valueF: "MaggioImp",
        },
        {
          text: "Giugno",
          align: "center",
          value: "Giugno",
          valueF: "GiugnoImp",
        },
        {
          text: "Luglio",
          align: "center",
          value: "Luglio",
          valueF: "LuglioImp",
        },
        {
          text: "Agosto",
          align: "center",
          value: "Agosto",
          valueF: "AgostoImp",
        },
        {
          text: "Settembre",
          align: "center",
          value: "Settembre",
          valueF: "SettembreImp",
        },
        {
          text: "Ottobre",
          align: "center",
          value: "Ottobre",
          valueF: "OttobreImp",
        },
        {
          text: "Novembre",
          align: "center",
          value: "Novembre",
          valueF: "NovembreImp",
        },
        {
          text: "Dicembre",
          align: "center",
          value: "Dicembre",
          valueF: "DicembreImp",
        },
      ],

      search: "",
      pagination: {
        rowsPerPage: 500,
      },

      startYear: 2018,
      annoSel: 0,
      anni: [],

      TotMesi: 0,
      Tot: [],

      isSelected: [],
      tuttiSel: true,

      dataSel: "",
      dataSelIT: new Date().toISOString().substr(0, 10),
      filtroGiornoAttivo: false,
      datiGiorno: "",

      filtroTipologia: "Quantita",
      numberFormatter: Intl.NumberFormat("it-IT"),

      currentSort: "RagSociale",
      currentSortDir: "asc",

      page: 1,
      pageCount: 0,
      itemsPerPage: 500,

      sortBy: 'RagSociale',
      sortDesc: false,

      dialogDataInizio: false,
    };
  },

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];
      this.pulisciTotaliMese();
      this.filtroGiornoAttivo = false;
      this.dataSelIT = "";
      this.datiGiorno = "";
      let par = "";

      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice)
        par = userSwitch.Tipo + "/" + userSwitch.Codice + "/";

      par += this.annoSel;

      let res = await get_riepilogoMensile(par);
      this.dati = res.data;

      this.calcolaTotali();
    },

    SelezionaTutti() {
      for (let i = 2; i < this.headers.length; i++) {
        this.isSelected[i] = true;
      }
    },

    calcolaTotali() {
      // Reset
      this.pulisciTotaliMese();
      for (let i = 0; i < 14; i++) {
        this.Tot[i] = 0;
      }
      if (this.filtroTipologia == "Quantita")
        this.dati.forEach((ord) => {
          this.Tot[1] += parseInt(ord.TotMesi);
          this.Tot[2] += parseInt(ord.Gennaio);
          this.Tot[3] += parseInt(ord.Febbraio);
          this.Tot[4] += parseInt(ord.Marzo);
          this.Tot[5] += parseInt(ord.Aprile);
          this.Tot[6] += parseInt(ord.Maggio);
          this.Tot[7] += parseInt(ord.Giugno);
          this.Tot[8] += parseInt(ord.Luglio);
          this.Tot[9] += parseInt(ord.Agosto);
          this.Tot[10] += parseInt(ord.Settembre);
          this.Tot[11] += parseInt(ord.Ottobre);
          this.Tot[12] += parseInt(ord.Novembre);
          this.Tot[13] += parseInt(ord.Dicembre);
        });
      else
        this.dati.forEach((ord) => {
          this.Tot[1] += parseInt(ord.TotMesiImp);
          this.Tot[2] += parseInt(ord.GennaioImp);
          this.Tot[3] += parseInt(ord.FebbraioImp);
          this.Tot[4] += parseInt(ord.MarzoImp);
          this.Tot[5] += parseInt(ord.AprileImp);
          this.Tot[6] += parseInt(ord.MaggioImp);
          this.Tot[7] += parseInt(ord.GiugnoImp);
          this.Tot[8] += parseInt(ord.LuglioImp);
          this.Tot[9] += parseInt(ord.AgostoImp);
          this.Tot[10] += parseInt(ord.SettembreImp);
          this.Tot[11] += parseInt(ord.OttobreImp);
          this.Tot[12] += parseInt(ord.NovembreImp);
          this.Tot[13] += parseInt(ord.DicembreImp);
        });
    },

    pulisciTotaliMese() {
      this.TotMesi = 0;
      this.Tot = [];
    },

    sommaMesi() {
      this.Tot[1] = 0;
      for (let i = 2; i < this.Tot.length; i++) {
        if (this.isSelected[i]) this.Tot[1] += this.Tot[i];
      }
    },

    getTotale() {
      this.sommaMesi();
      return this.Tot[1];
    },

    async esportaPdf() {
      let par = "";

      let userSwitch = this.$store.getters["user/getUserSwitch"];
      let role = this.role;

      if (userSwitch.Codice)
        par += "/" + userSwitch.Tipo + "/" + userSwitch.Codice;
      else if (role == "Cliente" || role == "Agente" || role == "AgenteCapo")
        par += "/" + role + "/" + this.$store.getters["user/getCodice"];

      par += "/" + this.annoSel;

      let res = await get_pdfOrdini(par);
      this.$i2kFunctions.createBlobPdf(res.data);
    },

    async cambioData() {
      this.filtroGiornoAttivo = true;

      let data = new Date(this.dataSel);
      data.setDate(data.getDate()); //formato system
      data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
      this.dataSelIT = data;

      let par = {
        Data: this.dataSel,
        Role: this.role,
        CodCliente: "",
        IdAgente: "",
      };

      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) {
        par.Role = userSwitch.Tipo;
        if (userSwitch.Tipo == "Cliente") {
          par.CodCliente = userSwitch.Codice;
        } else if (
          userSwitch.Tipo == "Agente" ||
          userSwitch.Tipo == "AgenteCapo"
        ) {
          par.IdAgente = userSwitch.Codice;
        }
      }

      let res = await get_riepilogoGiorno(par);

      this.datiGiorno = res.data.NumOrdini + " / " + res.data.Qta;
    },

    isSmartphone: function () {
      return this.$i2kFunctions.isSmartphone();
    },

    sortByColumn(column) {
      // Se la colonna cliccata è già quella di ordinamento, cambia la direzione
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        // Altrimenti, imposta la colonna di ordinamento e la direzione ascendente
        this.sortBy = column;
        this.sortDesc = false;
      }
    },

    /* sortBy(s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
      this.pagination.sortBy = s;

      this.pagination.descending = this.currentSortDir === "asc" ? false : true;
    }, */

    clickableItemStyle(i) {
      return {
        fontSize: i == 0 ? '1.2em' : '1.1em',
      };
    },

    getValue(item, month) {
      return this.filtroTipologia == 'Quantita' ? item[month] : this.commify(item[`${month}Imp`]);
    },

    commify(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },

  mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    this.$functions.delay(300);
    this.annoSel = this.$i2kFunctions.getYear();

    // Carico gli anni
    for (let i = this.startYear; i <= this.annoSel; i++) this.anni.push(i);
    this.SelezionaTutti();
    this.caricaDati();
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    role: function () {
      return this.$store.getters["user/getRole"];
    },

    months() {
      return [
        'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio',
        'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre',
        'Novembre', 'Dicembre'
      ];
    },

    headerStyle() {
      return {
        backgroundColor: '#d0bb5d',
        color: '#6a573e',
        maxWidth: '78dpx',
        textAlign: 'center',
      };
    },

    checkboxStyle() {
      return {
        marginBottom: '-15px',
        paddingBottom: '0px',
        transform: 'scale(0.8)',
      };
    },

    boldStyle() {
      return { fontSize: '1.1em' };
    },

  },

  watch: {
    userSwitch() {
      this.caricaDati();
    },

    tuttiSel(newVal, oldVal) {
      //se seleziono "Tutti" voglio che tutte le checkbox vengano selezionate, altrimenti le deseleziono tutte
      for (let i = 0; i < this.isSelected.length; i++) {
        this.isSelected[i] = newVal == true ? true : false;
      }
      this.sommaMesi;
    },

    filtroTipologia() {
      this.calcolaTotali();
    },
  },
};
</script>

<style scoped>
.totaliGriglia {
  padding: 0px;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  background: rgb(241, 237, 237);
}

table.v-table thead th {
  color: #6a573e;
  font-size: 12px;
}

table.v-table thead tr {
  background: #d0bb5d;
  border-bottom: 0px !important;
}

table.v-table tbody tr:last-child {
  border-bottom: 1px solid #d9d9d9;
}

table.v-table th:nth-child(1) {
  border-radius: 7px 0px 0px 7px;
}

table.v-table th:nth-last-child(1) {
  border-radius: 0px 7px 7px 0px;
}

table.v-table tbody td:not(:last-child) {
  border-right: 1px solid lightgray;
}

table.v-table tbody tr {
  cursor: pointer;
}

.clickable-item {
  cursor: pointer;
}

.bordoColonna {
  border-right: 1px solid black;
}
</style>
